import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getDocumentTypeList(params) {
  return request({
    url: URL.sys.documentType,
    method: 'get',
    params
  })
}
export function getDocumentTypeListFunc(params) {
  return request({
    url: URL.sys.documentTypeListUrl,
    method: 'get',
    params
  })
}

export function getDocumentType(uuid) {
  return request({
    url: URL.sys.documentTypeOne,
    method: 'get',
    params: { uuid: uuid }
  })
}

export function getDocTypeNextLevel(documentCategoryUuid) {
  return request({
    url: URL.sys.docTypeNextLevel,
    method: 'get',
    params: { documentCategoryUuid: documentCategoryUuid }
  })
}

export function docTypeCodeExists(code, uuid, lob) {
  const params = { code: code, uuid: uuid, lob: lob }
  return request({
    url: URL.sys.docTypeCodeExists,
    method: 'get',
    params
  })
}

export function addDocType(data) {
  return request({
    url: URL.sys.docType,
    method: 'post',
    data
  })
}

export function updateDocType(data) {
  return request({
    url: URL.sys.docType,
    method: 'put',
    data
  })
}

export function deleteDocType(uuid) {
  return request({
    url: URL.sys.docType,
    method: 'delete',
    params: { uuid }
  })
}

export function checkDocType(params) {
  return request({
    url: URL.sys.checkDocTypeUrl,
    method: 'get',
    params
  })
}

// 设置业务的默认文件类型
export function setDefaultDocumentType(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.setDefaultDocumentType,
    method: 'post',
    data
  })
}

